<template>
    <div v-if="isValid" id="outerNoticeDetail">
        <div class="main-container">
            <h1>{{title}}</h1>
            <div class="main-container__sub">
                <!--<div class="create-user">{{createUserName}}&nbsp;&nbsp;{{createTime | timeSuffixFilter}}</div>-->
                <!--<div class="signup-info">招生登记日期：{{startDate | secondTimeFilter}}——{{endDate | secondTimeFilter}}</div>-->
                <image-previewer tag="richtext">
                    <div class="content" v-html="recruitDesc"></div>
                </image-previewer>
            </div>
        </div>
        <div v-if="isStart && status !== 1" class="btn-container">
            <el-button type="primary" @click.native="jumpToPage('outerLogin', {id, schoolId, voteId})">
                {{ isEnd ? '查看报名' :'我要报名'}}
            </el-button>
        </div>
    </div>
    <default-page v-else mes="非法操作"></default-page>
</template>

<script>
    import {mapMutations} from 'vuex';
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer';
    import QRCode from 'qrcode'
    import moment from 'moment';
    import {
        getVoteTwoRecruitNotice
    } from '@/api/outer';
    import {getCurrentSchoolTimeBySchoolId} from '@/api/common';
    import baseMixin from '@/mixins/baseMixin';
    import DefaultPage from '@/components/DefaultPage';

    export default {
        name: "OuterNotice",
        data() {
            return {
                id: this.$route.query.id,
                title: '',
                recruitDesc: '',
                startDate: '',
                endDate: '',
                voteId: '',
                createUserName: '',
                createTime: '',
                schoolId: this.$route.query.schoolId,
                isStart: false,
                isEnd: false,
                status: 1,
                qrcodeUrl: '',
                isValid: true,
                url: ''
            }
        },
        components: {
            ImagePreviewer,
            DefaultPage
        },
        filters: {
            secondTimeFilter(value) {
                return value.substring(0, 16);
            }
        },
        mixins: [baseMixin],
        created() {
            sessionStorage.setItem('outerNoticeId', this.$route.query.id);
            getCurrentSchoolTimeBySchoolId({
                schoolId: this.schoolId
            })
                .then(res => res.data)
                .then(data => {
                    this.SET_SELECTED_SCHOOLYEAR(data.schoolYear);
                    getVoteTwoRecruitNotice({
                        noticeId: this.id
                    })
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                const pageData = data.data;
                                this.title = pageData.title;
                                this.recruitDesc = pageData.recruitDesc;
                                this.startDate = pageData.startDate;
                                this.endDate = pageData.endDate;
                                this.voteId = pageData.voteId;
                                this.createUserName = pageData.createUserName;
                                this.createTime = pageData.createTime;
                                if (pageData.schoolId != this.schoolId) {
                                    this.isValid = false;
                                }
                                this.voteId = pageData.voteId;
                                this.status = pageData.status;

                                const currentDate = moment().format('YYYY-MM-DD HH:mm:ss');
                                this.isStart = currentDate >= pageData.startDate;
                                this.isEnd = currentDate > pageData.endDate;

                                if (pageData.status === 1) {
                                    this.$message.error('该意向登记尚未发布');
                                }
                                const baseHref = this.basePath.indexOf('test') !== -1 ? 'https://test.weixiaojia.cn/mobile/#/' : 'https://m.www.weixiaojia.cn/mobile/#/';

                                this.url = `${baseHref}schoolSignup/notice?id=${this.id}&schoolId=${pageData.schoolId}`;
                                QRCode.toDataURL(`${baseHref}schoolSignup/notice?id=${this.id}&schoolId=${pageData.schoolId}`)
                                    .then(url => {
                                        this.qrcodeUrl = url;
                                    })
                                    .catch(err => {
                                    });
                            }
                        })
                })

        },
        methods: {
            ...mapMutations(['SET_SELECTED_SCHOOLYEAR'])
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";

    .table-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
    }

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }

    .main-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
        z-index: 3000;
        position: relative;

        .main-container__sub {
            width: 60%;
            margin: 0 auto;
        }

        h1 {
            text-align: center;
        }

        .content {
            width: 80%;
            margin: 0 auto;
            @include richtext;
        }

        .create-user {
            float: right;
        }

        .signup-info {
            clear: both;
            text-align: center;
        }
    }

    .btn-container {
        z-index: 3000;
        position: relative;
        text-align: center;
    }

    .qrcode-container {
        z-index: 3000;
        position: relative;
        text-align: center;
    }

</style>
<style lang="scss">
    @import "../../../styles/mixin.scss";

    #outerNoticeDetail {
        .content {
            width: 80%;
            margin: 0 auto;
            @include richtext;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/kindergarten/outer/OuterNotice.vue